module.exports = __webpack_public_path__ + "static/media/huli_451.dbff5afc.png";